export const getIsExpiredCard = (expMonth: number, expYear: number) => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  return (
    expYear < currentYear ||
    (expYear === currentYear && expMonth < currentMonth)
  );
};
